<template>
    <div>
        <a-spin :spinning="isloading" tip="加载中...">
            <div class>
                <div class="mainWrapper clearfix">
                    <div>
                        <div class="pxkeji-right-box" style="margin-top:0">
                            <a-table
                                    :columns="list.columns"
                                    :dataSource="list.datas"
                                    :loading="isloading"
                                    :locale="{emptyText:'暂无数据'}"
                            >
                                <template
                                        v-for="col in ['id', 'presentPrice']"
                                        :slot="col"
                                        slot-scope="text, record, index"
                                >
                                    <div :key="col">
                                        <a-input
                                                v-if="record.editable"
                                                style="margin: -5px 0"
                                                :value="text"
                                                @change="e => handleChange(e.target.value, record.key, col)"
                                        />
                                        <template v-else>
                                            {{ text }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="operation" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
        <span v-if="record.editable">
          <a @click="() => save(record.key)">保存</a>
          <a-popconfirm title="你确定要取消吗?" @confirm="() => cancel(record.key)">
            <a>取消</a>
          </a-popconfirm>
        </span>
                                        <span v-else>
          <a :disabled="editingKey !== ''" @click="() => edit(record.key)">修改</a>
        </span>
                                    </div>
                                </template>
                            </a-table>
                            <a-button type="primary" :style="{ margin:'10px'}" @click="choseBack">保存</a-button>
                        </div>
                    </div>
                </div>

            </div>
        </a-spin>
    </div>
</template>

<script>
    var that;
    const columns = [
        {
            dataIndex: "name",
            key: "name",
            align: "center",
            title: "课程名称",
            scopedSlots: { customRender: 'name' },
        },
        {
            dataIndex: "presentPrice",
            key: "presentPrice",
            align: "center",
            title: "课程价格",
            scopedSlots: { customRender: 'presentPrice' },
        },
        {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    export default {
        props: {
            courseIds: String,
            buyCourseIds: String
        },
        data() {

            return {
                data:[],
                cacheData:[],
                columns,
                editingKey: '',
                classList: [],
                replaceFields: {children: "children", title: "name", key: "id"},
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10 //页容
                    }
                },
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件
                        courseName: "",
                        typeId: null,
                    }
                },
                allSelectRows: [],
                selectRows: [], //选中项编号
                isloading: false,
            };
        },
        mounted() {
            this.$nextTick(() => {
                that = this;
                // this.allSelectRows = this.ids ? this.ids : [];
                this.GetList();
            });
        },
        methods: {
            handleChange(value, key, column) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    this.list.datas = newData;
                    console.log(newData)
                }
            },
            edit(key) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = key;
                if (target) {
                    target.editable = true;
                    this.list.datas = newData;
                }

            },
            save(key) {
                const newData = [...this.list.datas];
                const newCacheData = [...this.cacheData];
                const target = newData.filter(item => key === item.key)[0];
                const targetCache = newCacheData.filter(item => key === item.key)[0];
                if (target && targetCache) {
                    delete target.editable;
                    this.list.datas = newData;
                    Object.assign(targetCache, target);
                    this.cacheData = newCacheData;
                }
                this.editingKey = '';
            },
            cancel(key) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = '';
                if (target) {
                    Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
                    delete target.editable;
                    this.list.datas = newData;
                }
            },

            GetList() {
                this.isloading = true;
                this.$api.course
                    .getChooseCourseInfoList(
                        this.courseIds,
                        this.buyCourseIds
                    )
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            // this.list.datas = res.data;
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.datas.push({
                                    key: i.toString(),
                                    id: res.data[i].id,
                                    name: res.data[i].name,
                                    presentPrice: res.data[i].presentPrice,
                                });
                            }
                            this.cacheData = this.list.datas.map(item => ({ ...item }));


                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            //选择并返回
            choseBack() {

                this.$emit("callbackMethod",JSON.stringify(this.list.datas));
            }
        }
    };
</script>
<style>
    .mainWrapper {
        box-sizing: border-box !important;
    }

    .articleMeauleft {
        width: 20%;
        padding: 0 1%;
        min-height: 700px;
        background: #fff;
        float: left;
        margin-top: 24px;
    }


    .courseClass {
        padding-left: 10px;
    }

    .courseClass span {
        font-size: 14px;
        line-height: 2.5;
        cursor: pointer;
    }
</style>